const _ = require('lodash');

function ogProductLocaleFilter($translate, caseConversionService, localeFormat) {
  return function(product, property) {
    const currentLocale = $translate.use();

    if (currentLocale === 'en_US') {
      return product[property];
    }

    let i18nDisplay = _.get(product.extraData, ['i18n_display'], {});
    i18nDisplay = _.mapKeys(i18nDisplay, (value, key) => localeFormat.formatLocaleString(key));
    let productLocale = _.get(i18nDisplay, currentLocale, {});
    productLocale = caseConversionService.convertObjectPropertiesToCamel(productLocale);
    return productLocale[property] || product[property];
  };
}

ogProductLocaleFilter.$inject = ['$translate', 'caseConversionService', 'localeFormat'];

module.exports = ogProductLocaleFilter;
